var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"news-full"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('Modules',{attrs:{"modules":_vm.modules}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }